import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/common/CommunitySection.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/components/common/FreeCoursesSectionInCourse.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/components/common/whatsapp.css");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/components/courses/course-features/CourseFeatureSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/courses/courses/AllCourses.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/courses/premium-hero/PremiumHero.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/script.js");
